import { Reveal } from "@/components/Reveal";

// Elegant press-mention ticker. Uses stylised wordmarks (not copyrighted logos),
// which is a common premium pattern when official brand assets aren't cleared.
const OUTLETS = [
  { name: "Man of Many" },
  { name: "Pickr" },
  { name: "Tech Daily with Andy Wells" },
  { name: "ABC Radio National" },
  { name: "BBC Science Focus" },
  { name: "T3" },
  { name: "TechRadar" },
  { name: "BBC Radio 4 — You and Yours" },
  { name: "Which? — Just Buy This" },
];

const Row = () => (
  <>
    {OUTLETS.concat(OUTLETS).map((o, i) => (
      <li
        key={`${o.name}-${i}`}
        className="flex shrink-0 items-center gap-10"
      >
        <span className="font-heading whitespace-nowrap text-base font-black tracking-tight text-tracksy-ink/85 sm:text-xl md:text-2xl">
          {o.name}
        </span>
        <span
          aria-hidden="true"
          className="h-1.5 w-1.5 shrink-0 rounded-full bg-tracksy-orange/70"
        />
      </li>
    ))}
  </>
);

const PressTicker = () => (
  <section
    data-testid="press-ticker-section"
    aria-label="As featured in"
    className="relative border-y border-black/5 bg-tracksy-paper py-3.5 sm:py-6"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-2.5 px-4 sm:flex-row sm:items-center sm:gap-6 sm:px-6 lg:px-8">
      <Reveal>
        <p
          className="shrink-0 text-[9px] font-black uppercase tracking-[0.22em] sm:text-[11px] sm:tracking-[0.25em] transition-colors duration-500"
          style={{ color: "var(--brand-accent)" }}
        >
          Discussed by
        </p>
      </Reveal>

      {/* Scrolling marquee with edge-fade mask */}
      <div
        className="marquee-paused relative w-full overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
        }}
      >
        <ul className="flex min-w-max items-center gap-8 pr-8 animate-marquee-slow sm:gap-10 sm:pr-10">
          <Row />
        </ul>
      </div>
    </div>
  </section>
);

export default PressTicker;
